// Copyright (c) 2026 AesirX.io Ltd. All rights reserved.
// This source code is proprietary and confidential.
// See LICENSE.md for licensing terms.
export const ORG_IDENTITY_FIELD_DEFINITIONS = [
    { field: 'legal_name', kind: 'text', max_length: 300 },
    { field: 'trading_name', kind: 'text', max_length: 300 },
    { field: 'head_office_address', kind: 'multiline', max_length: 1000 },
    { field: 'transaction_office_address', kind: 'multiline', max_length: 1000 },
    { field: 'registration_number', kind: 'text', max_length: 100 },
    { field: 'registration_instrument', kind: 'text', max_length: 300 },
    { field: 'registration_issuer', kind: 'text', max_length: 300 },
    { field: 'registration_issue_date', kind: 'date', max_length: 10 },
    { field: 'registration_issue_place', kind: 'text', max_length: 300 },
    { field: 'tax_code', kind: 'text', max_length: 64 },
    { field: 'phone', kind: 'phone', max_length: 40 },
    { field: 'email', kind: 'email', max_length: 254 },
    { field: 'website', kind: 'url', max_length: 500 },
    { field: 'legal_representative_name', kind: 'text', max_length: 300 },
    { field: 'legal_representative_title', kind: 'text', max_length: 300 },
];
export const ORG_IDENTITY_FIELDS = ORG_IDENTITY_FIELD_DEFINITIONS.map((d) => d.field);
/**
 * The three `branding` keys the start-up migration copies into an empty
 * identity, and the identity field each lands in. `registration_number` stays
 * a registration number: the cover letter used to print it as the tax code,
 * which it is not.
 */
export const ORG_BRANDING_TO_IDENTITY = [
    { branding: 'organization_name', identity: 'legal_name' },
    { branding: 'address', identity: 'head_office_address' },
    { branding: 'registration_number', identity: 'registration_number' },
];
/** A calendar date as the identity stores it. */
export const ORG_IDENTITY_DATE_PATTERN = /^\d{4}-\d{2}-\d{2}$/;
/** True when `value` is a real calendar date in `YYYY-MM-DD`. */
export function isOrgIdentityDate(value) {
    if (!ORG_IDENTITY_DATE_PATTERN.test(value))
        return false;
    const [y, m, d] = value.split('-').map(Number);
    const date = new Date(Date.UTC(y, m - 1, d));
    return date.getUTCFullYear() === y && date.getUTCMonth() === m - 1 && date.getUTCDate() === d;
}
/** Digits, spaces, `+`, `(`, `)`, `.`, `-` and `/` (for an extension): no letters. */
export const ORG_IDENTITY_PHONE_PATTERN = /^\+?[0-9 ().\-/]{3,40}$/;
//# sourceMappingURL=org-identity.js.map